<template>
  <section>
    <h3 class="title text-center" v-if="!tramite">
      {{ $t("seguimiento.title") }}
    </h3>
    <div class="card">
      <div class="card-body">
        <form @submit.prevent="buscar" v-if="!tramite" class="grid-form">
          <div class="alert alert-info">
            <i class="icon-info"></i>
            {{ $t("fields.ingrese_codigo_seguimiento") }}
          </div>
          <div class="grid cols-2">
            <div class="grid cols-2">
              <div
                class="form-group required"
                :class="{ 'error-input': errors.has('codigo') }"
              >
                <label for="codigo">{{ $t("fields.codigo") }}</label>
                <input
                  type="text"
                  v-model="codigo"
                  id="codigo"
                  name="codigo"
                  autofocus
                  maxlength="8"
                  v-validate="'required'"
                  autocomplete="off"
                  class="form-control"
                />
                <span v-show="errors.has('codigo')" class="error-help">{{
                  errors.first("codigo")
                }}</span>
              </div>
              <div class="form-group">
                <label for="">&nbsp;</label>
                <button class="btn btn-primary" type="submit">
                  {{ $t("btn.search") }} <i class="icon-checkmark"></i>
                </button>
              </div>
            </div>
          </div>
        </form>
        <div v-if="tramite" class="tramite-detalle grid-form">
          <div class="grid detalle">
            <h3 class="title">{{ $t("fields.det_tramite") }}</h3>
            <div class="info">
              <div>
                <strong>{{ $t("fields.fecha_solicitud") }}: </strong
                >{{ $util.formatDate(tramite.fecha_inicio) }}
              </div>
              <div>
                <strong>{{ $t("fields.estado") }}:</strong> {{ tramite.estado }}
              </div>
            </div>
          </div>
          <h4 class="title">{{ $t("fields.datos_del_solicitante") }}</h4>
          <div class="grid cols-3">
            <div class="form-group">
              <label for="">{{ $t("fields.nombre_solicitante") }}</label>
              <p class="form-control">
                {{ tramite["solicitante.nombres"] }}
                {{ tramite["solicitante.primer_apellido"] }}
                {{ tramite["solicitante.segundo_apellido"] }}
              </p>
            </div>
            <div class="form-group">
              <label for="">{{ $t("fields.email") }}</label>
              <p class="form-control">{{ tramite["solicitante.email"] }}</p>
            </div>
            <div class="form-group">
              <label for="">{{ $t("fields.telefono") }}</label>
              <p class="form-control">{{ tramite["solicitante.telefono"] }}</p>
            </div>
            <div class="form-group">
              <label for="">{{ $t("fields.tipoDoc") }}</label>
              <p class="form-control">
                {{ tipoDocs[tramite["solicitante.tipo_documento"]] }}
              </p>
            </div>
            <div class="form-group">
              <label for="">{{ $t("fields.nroDoc") }}</label>
              <p class="form-control">
                {{ tramite["solicitante.nro_documento"] }}
              </p>
            </div>
            <div class="form-group">
              <!-- label for="">{{ $t("fields.fecha_nacimiento") }}</label>
              <p class="form-control">
                {{ $util.formatDate(tramite["solicitante.fecha_nacimiento"]) }}
              </p -->
            </div>
          </div>
          <div
            class="alert alert-info"
            v-if="tramite['tramitadore.nro_documento']"
          >
            <i class="icon-info"></i>La solicitud fue realizada por un
            apoderado.
          </div>
          <div class="grid cols-3" v-if="tramite['tramitadore.nro_documento']">
            <div class="form-group">
              <label for="">{{ $t("fields.nombre_apoderado") }}</label>
              <p class="form-control">
                {{ tramite["tramitadore.nombres"] }}
                {{ tramite["tramitadore.primer_apellido"] }}
                {{ tramite["tramitadore.segundo_apellido"] }}
              </p>
            </div>
            <div class="form-group">
              <label for="">{{ $t("fields.tipoDoc") }}</label>
              <p class="form-control">
                {{ tipoDocs[tramite["tramitadore.tipo_documento"]] }}
              </p>
            </div>
            <div class="form-group">
              <label for="">{{ $t("fields.nroDoc") }}</label>
              <p class="form-control">
                {{ tramite["tramitadore.nro_documento"] }}
              </p>
            </div>
            <div class="form-group">
              <label for="">{{ $t("fields.fecha_nacimiento") }}</label>
              <p class="form-control">
                {{ $util.formatDate(tramite["tramitadore.fecha_nacimiento"]) }}
              </p>
            </div>
          </div>

          <h4 class="title">{{ $t("fields.docs") }}</h4>
          <div class="documentos grid cols-2">
            <div
              class="documento card"
              v-for="(item, index) in documentosVista"
              :key="`k${index}`"
            >
              <div class="grid estado">
                <div>
                  <h5 class="title">
                    {{ index + 1 }}. {{ item["documento.nombre"] }}
                    <span v-if="item.grupo_size > 1">(x{{ item.grupo_size }})</span>
                  </h5>
                  <p>{{ item["documento.descripcion"] }}</p>
                  <!-- p>
                    <small
                      >{{ $t("fields.vigencia_documento") }}:<strong>
                        {{ item["documento.vigencia"] }} meses
                      </strong></small
                    >
                  </p -->
                  <p>
                    {{
                      item["documento.clasificacion"] === "EMITIDO_TERCEROS"
                        ? "-Emitido por terceros"
                        : "-Emitido por MINEDU"
                    }}
                  </p>
                  <p v-if="item.para_apostillar">
                    {{
                      item.para_apostillar === true ? "-Para APOSTILLAR" : ""
                    }}
                  </p>
                  <p class="entidad">
                    <small>{{ item["documento.entidad.nombre"] }}</small>
                  </p>
                </div>
                <div class="text-center">
                  <div
                    class="caducado"
                    v-if="
                      item.estado === 'FIRMADO_ENTIDAD' &&
                        new Date(item.fecha_limite_revisado).getTime() <
                          new Date(Date.now()).getTime()
                    "
                  >
                    <strong> SOLICITUD CADUCADA </strong>
                  </div>
                  <div
                    class="precio"
                    v-else-if="
                      item.estado === 'FIRMADO_ENTIDAD' &&
                        item['documento.derivar'] === 'MINEDU'
                    "
                  >
                    {{ $t("fields.estado") }}:
                    <strong> CREADO </strong>
                  </div>

                  <div class="precio" v-else>
                    {{ $t("fields.estado") }}:
                    <strong>
                      {{ item.estado.replace(new RegExp("_", "g"), " ") }}
                    </strong>
                  </div>

                  <div
                    @click="realizarPago(item)"
                    class="precio deuda"
                    v-if="mostrarBotonPago(item)"
                  >
                    <i class="icon-checkmark"></i>
                    Habilitado para<br />
                    realizar el pago
                  </div>

                  <div
                    @click="verCodigo(item['pagos.cpt'])"
                    class="precio cpt"
                    v-if="mostarCodigoGenerado(item)"
                  >
                    <!-- Código de pago Generado<br /> -->
                    <strong>Ver código de pago generado</strong>
                  </div>

                  <div
                    class="precio pago"
                    v-if="item.pago_minedu || item.pago_entidad"
                  >
                    <strong> Trámite Pagado </strong>
                  </div>

                  <div class="precio" v-if="item.grupo_size > 1">
                    {{ $t("fields.precio") }}:
                    <strong>{{ item["documento.precio"] }}</strong> Bs. x
                    {{ item.grupo_size }} =
                    <strong>{{ item.grupo_total }}</strong> Bs.
                  </div>
                  <div class="precio" v-else>
                    {{ $t("fields.precio") }}:
                    <strong>{{ item["documento.precio"] }}</strong> Bs.
                  </div>
                </div>
              </div>
              <div
                class="form-group alert alert-warning"
                v-if="item.observacion"
              >
                <label for="">Observación</label>
                <p>{{ item.observacion }}</p>
              </div>

              <div
                class="form-group"
                v-if="item.estado === 'OBSERVADO_MINEDU_REVISOR'"
              >
                <label>
                  <span class="mr-10"
                    >Fecha límite para subsanar la observación:</span
                  >
                  <strong>{{
                    $util.formatDate(item.fecha_limite_revisado)
                  }}</strong>
                </label>
              </div>

              <!-- div
                class="form-group"
                v-else-if="
                  item['documento.clasificacion'] === 'EMITIDO_TERCEROS' ||
                    (item['documento.adjunto_obligatorio'] &&
                      item.gestion <= item['documento.gestion_fin'])
                "
              >
                <label>
                  <span class="mr-10"
                    >Fecha límite para presentar documento original:</span
                  >
                  <strong>{{
                    $util.formatDate(item.fecha_limite_revisado)
                  }}</strong>
                </label>
              </div -->

              <div class="grid cols-2">
                <div
                  class="form-group"
                  v-if="item['documento.derivar'] === 'ENTIDAD'"
                >
                  <label>
                    <span class="mr-10">{{ $t("fields.pago_entidad") }}:</span>
                    <i
                      :class="{
                        'icon-checkmark': item.pago_entidad,
                        'icon-cross': !item.pago_entidad
                      }"
                    ></i>
                    <strong>{{
                      item.pago_entidad ? "SI" : "NO"
                    }}</strong></label
                  >
                </div>
                <div
                  class="form-group"
                  v-if="item['documento.derivar'] === 'MINEDU'"
                >
                  <label>
                    <span class="mr-10">{{ $t("fields.pago_minedu") }}:</span>
                    <i
                      :class="{
                        'icon-checkmark': item.pago_minedu,
                        'icon-cross': !item.pago_minedu
                      }"
                    ></i>
                    <strong>{{ item.pago_minedu ? "SI" : "NO" }}</strong></label
                  >
                </div>
              </div>
              <div class="grid cols-3">
                <div class="form-group" v-if="item.cod_seguridad">
                  <label for="">{{ $t("fields.cod_seguridad") }}</label>
                  <p class="form-control">{{ item.cod_seguridad }}</p>
                </div>
                <div class="form-group" v-if="item.nro_legalizacion">
                  <label for="">{{ $t("fields.nro_legalizacion") }}</label>
                  <p class="form-control">{{ item.nro_legalizacion }}</p>
                </div>
                <div class="form-group" v-if="item.fecha_expedicion">
                  <label for="">{{ $t("fields.fecha_expedicion") }}</label>
                  <p class="form-control">
                    {{ $util.formatDate(item.fecha_expedicion) }}
                  </p>
                </div>
              </div>
            </div>
            <!-- <div class="total">
              Total a pagar: {{ total() }} Bs.
            </div> -->
          </div>
          <div class="btn-container">
            <button class="btn" @click="back">
              {{ $t("btn.back") }} <i class="icon-arrow-left2"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
const tipoDocs = {
  CI: "CÉDULA DE IDENTIDAD",
  EXTRANJERO: "DOCUMENTO DE IDENTIFICACIÓN EXTRANJERO"
};

export default {
  data () {
    return {
      dialog: false,
      codigo: "",
      tramite: null,
      tipoDocs,
      processId: null,
      vwin: null,
      idtramitedoc: 0
    };
  },

  computed: {
    // Colapsa los documentos "agrupables" del mismo tipo en una sola tarjeta
    // (pago único por el monto total del grupo: precio unitario x N)
    documentosVista () {
      if (!this.tramite || !this.tramite.documentos) {
        return [];
      }
      const grupos = {};
      this.tramite.documentos.forEach(doc => {
        if (doc["documento.agrupable"]) {
          const key = doc["documento.sigla"] || doc["documento.nombre"];
          (grupos[key] = grupos[key] || []).push(doc);
        }
      });
      const infoGrupo = {}; // id del representante -> { size, total }
      const ocultos = new Set(); // ids de miembros no representantes
      Object.values(grupos).forEach(members => {
        if (members.length < 2) {
          return;
        }
        const rep = members.reduce((a, b) =>
          parseInt(a.id) < parseInt(b.id) ? a : b
        );
        infoGrupo[parseInt(rep.id)] = {
          size: members.length,
          total: (parseFloat(rep["documento.precio"]) * members.length).toFixed(2)
        };
        members.forEach(m => {
          if (parseInt(m.id) !== parseInt(rep.id)) {
            ocultos.add(parseInt(m.id));
          }
        });
      });
      return this.tramite.documentos
        .filter(doc => !ocultos.has(parseInt(doc.id)))
        .map(doc => {
          const g = infoGrupo[parseInt(doc.id)];
          return Object.assign({}, doc, g
            ? { grupo_size: g.size, grupo_total: g.total }
            : { grupo_size: 1 });
        });
    }
  },

  methods: {
    mostrarBotonPago (item) {
      const codigoGenerado = item["pagos.cpt"] ? !!(item["pagos.cpt"].detalleMedioPago) : false;
      const pagoPendiente =
        !codigoGenerado &&
        !item.pago_minedu &&
        !item.pago_entidad &&
        item["pagos.estado"] === "HABILITADO" &&
        item.estado.startsWith('REVISADO');
      return pagoPendiente;
    },

    mostarCodigoGenerado (item) {
      let codigoPagoGenerado =
        item["pagos.cpt"] &&
        !item.pago_minedu &&
        !item.pago_entidad &&
        item["pagos.cpt"].detalleMedioPago;

      codigoPagoGenerado =
        !!codigoPagoGenerado &&
        item["pagos.cpt"].estado === "EN_PROCESO" &&
        item["pagos.estado"] === "HABILITADO" &&
        item["pagos.cpt"].metodoPago;

      return codigoPagoGenerado;
    },

    verCodigo (item) {
      const detallePago = item.detalleMedioPago;
      if (item.metodoPago === "PPTE") {
        this.$modal.confirm(
          `<div>
            <h3 class="title text-center">CPT (Código de Pago de Trámite)</h3>
            <h3 class="title text-center"><strong>${detallePago.cpt}</strong></h3>
            <p class="text-center">Realiza el pago desde UNINET, UNIMOVIL Y CAJEROS BANCO UNIÓN</p>
            <p class="text-center">Fecha Límite: <strong>${detallePago.fechaValidez}</strong></p>
          </div>`
        );
      } else if (item.metodoPago === "QR") {
        this.$modal.confirm(
          `<div>
            <img src="${detallePago.codigoQr}" alt="Código QR fue enviado a su correo electrónico"/>
          </div>`
        );
      }
    },

    async buscar () {
      if (await this.$validator.validateAll()) {
        this.$service.get(`tramite/${this.codigo}`).then(response => {
          if (response) {
            this.tramite = response;
          }
        });
      }
    },

    back () {
      this.tramite = null;
      this.codigo = "";
    },

    realizarPago (item) {
      var data = { item };
      this.$service.post2(`regeneradeuda/${item.id}`, data).then(response => {
        if (response.data.code === -1 || response.code === -1) {
          this.$message.warning(response.message);
          return;
        }

        this.$loading.show(
          "Pasarela de Pagos en proceso ... <br />cierre la pasarela para continuar. !!!"
        );
        this.vwin = window.open(
          response.data.urlRedireccion,
          "PPE",
          "width=800,height=600"
        );

        this.processId = setInterval(() => {
          if (this.vwin.closed) {
            clearInterval(this.processId);
            this.$loading.hide();
            this.tramite = null;
            this.buscar();
          }
        }, 1000);
      });
    }
  }
};
</script>

<style lang="scss">
@import "pages.scss";
.tramite-detalle {
  .documentos {
    .card {
      padding: 20px;
    }
  }

  .alert {
    margin-top: 10px;
  }

  .documentos {
    .precio {
      margin-bottom: 5px;
      text-align: center;
      font-size: 0.8rem;

      &:first-child {
        background-color: $primary;
      }
    }
  }
}
.grid {
  &.detalle {
    grid-template-columns: 3fr 1fr;

    .info {
      margin-top: 10px;
    }
  }
  &.estado {
    grid-template-columns: 4fr 2fr;
    margin-bottom: 15px;
  }
}

.deuda {
  padding: 18px !important;
  background-color: #044d7b !important;
  cursor: pointer !important;
}

.cpt {
  padding: 18px !important;
  background-color: #e19900 !important;
  cursor: pointer !important;
}

.pago {
  padding: 18px !important;
  background-color: #148d1d !important;
  cursor: pointer !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Seguimiento.vue